import DSBox from "views/system-design/DSBox";
import DSTypography from "views/system-design/DSTypography";
import Calendar, { CalendarDay } from "views/CalendarEvent/components/Calendar";
import { Ticket } from "../../types";
import TicketChip from "./TicketChip";

interface MonthViewProps {
  currentDate: Date;
  onDateChange: (date: Date) => void;
  ticketsByDay: Map<string, Ticket[]>;
  onSelectTicket: (ticket: Ticket) => void;
}

const VISIBLE_TICKETS_PER_DAY = 3;

export default function MonthView({
  currentDate,
  onDateChange,
  ticketsByDay,
  onSelectTicket,
}: MonthViewProps) {
  const renderDayContent = (day: CalendarDay) => {
    const dayKey = day.date.toDateString();
    const dayTickets = ticketsByDay.get(dayKey) ?? [];
    if (dayTickets.length === 0) return null;
    const overflowCount = dayTickets.length - VISIBLE_TICKETS_PER_DAY;
    return (
      <DSBox
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
          overflow: "hidden",
        }}
      >
        {dayTickets.slice(0, VISIBLE_TICKETS_PER_DAY).map((ticket) => (
          <TicketChip
            key={ticket.id}
            ticket={ticket}
            onSelectTicket={onSelectTicket}
          />
        ))}
        {overflowCount > 0 && (
          <DSTypography
            variant="caption"
            sx={{ color: "text.secondary", pl: 0.5 }}
          >
            +{overflowCount} more
          </DSTypography>
        )}
      </DSBox>
    );
  };

  return (
    <Calendar
      currentDate={currentDate}
      onDateChange={onDateChange}
      renderDayContent={renderDayContent}
      minHeight={140}
    />
  );
}
